import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

interface ITitleObj {
    title: string; // 页面标题
    isSelected: boolean; // 是否选中
    url: string; // 对应路由
}

@Component({
    selector: 'clink-page-header',
    templateUrl: 'page-header.component.html',
    styleUrls: ['page-header.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
    @Input() hasBack? = false; // 是否有返回图标
    @Input() title?: string; // 主标题
    @Input() titleList?: ITitleObj[]; // 主标题列表
    @Input() smallTitle?: string; // 副标题
    @Input() smallTitleWithBrackets = true; // 副标题是否使用括号包裹
    @Input() smallTitleColor?: string = null; // 副标题颜色
    @Input() smallIcon?: string; // 副标题图标
    @Input() smallFontSize?: string; // 副标题字号
    @Input() border = true; // 是否显示border bottom
    @Input() judge?: boolean; // 主按钮背景颜色是否为灰色
    @Input() rightButtons?: any[]; // header 右边的按钮，从左到右依次排列
    @Input() iconBtns?: any[]; // header 左边的数组，icon类型的button
    @Input() tooltip? = false; // 控制标题是否加悬浮效果
    @Input() maxTitleCharLen: number; // 标题最多展示字符数
    @Input() showTips? = false; // 主标题右侧提示icon
    @Input() tooltipTitle?: string = null; // 提示icon文本 和showTips绑定传入
    @Input() hasDescription? = false; // 是否有字段说明功能
    @Output() tapRightBtn = new EventEmitter(); // 有list选择item时
    @Output() back = new EventEmitter(); // 页面返回
    @Output() subTitleClick = new EventEmitter(); // 点击副标题
    @Output() getIndex = new EventEmitter(); // 变更选中标题下标
    @Output() goDescription = new EventEmitter(); // 查看字段说明

    constructor(public router: Router, private location: Location) {}

    /**
     * 点击操作按钮
     */
    clickRightBtn(button, action: string): void {
        button.showMenu = false;
        this.tapRightBtn.emit(action);
    }

    /**
     * 返回
     */
    goBack(): void {
        if (this.back) {
            this.back.emit();
        } else {
            this.location.back();
        }
    }

    /**
     * 点击副标题
     */
    clickSmallTitle(): void {
        this.subTitleClick.emit();
    }

    /**
     * 变更选中标题下标
     *
     * @param {*} index
     * @memberof PageHeaderComponent
     */
    changeShowTitleIndex(index) {
        this.getIndex.emit(index);
    }

    /**
     * 查看字段说明
     *
     * @memberof PageHeaderComponent
     */
    goFieldDescription() {
        this.goDescription.emit();
    }
}
